import React from 'react';
import PropTypes from 'prop-types';
import htmlParser from 'html-react-parser';
import { decodeHtml, isStringNullUndefinedEmpty } from './Helpers/ContentHelpers';
import { isNullOrUndefined } from 'util';

class AlertMessageDismissible extends React.Component {
    constructor(props) {
        super(props);
        this.isDismissible = isNullOrUndefined(this.props.isDismissible) || this.props.isDismissible;
        this.isTextAllBold = isNullOrUndefined(this.props.isTextAllBold) || this.props.isTextAllBold;
        this.state = {};
    }

    styleMessage = () => ({
        display: isStringNullUndefinedEmpty(this.props.text) ? 'none' : 'block'
    });

    iconClass = () => {
		var ret = 'fas fa-exclamation-circle align-self-center mr-3 fa-2x';
        if (this.props.type === 'success') {
            ret = 'fas fa-check-circle align-self-center mr-3 fa-2x';
        } else if (this.props.type === 'info') {
            ret = 'fas fa-info-circle align-self-center mr-3 fa-2x';
        }
        return ret;
    }

	handleOnClick = (e) => {
		if (!this.isDismissible) {
			return;
		}

        this.props.onClick(e);
    }

    render = () => {
        const alertClass = `alert alert-${this.props.type}`;
        const textClass = "media-body align-self-center" + (this.isTextAllBold ? " bold" : "");
        const htmlText = decodeHtml(this.props.text);
        const htmlEl = htmlParser(htmlText);
        return (
			<div style={this.styleMessage()} title="Close" id={this.props.id}>
                <div className={alertClass} role="alert">
					{this.isDismissible &&
						<button type="button" className="close" onClick={this.handleOnClick}>
							<span aria-hidden="true">&times;</span>
						</button>
					}
                    <div className="media">
                        <i className={this.iconClass()} />
                        <div className={textClass}>
                            {htmlEl}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AlertMessageDismissible;

AlertMessageDismissible.propTypes = {
   // text: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['danger', 'warning', 'info', 'success']).isRequired,
	onClick: PropTypes.func.isRequired,
	isDismissible: PropTypes.bool
};

AlertMessageDismissible.defaultTypes = {
    text: '',
    type: 'danger',
	onClick: () => { },
	isDismissible: true
};